import React from "react";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <h1 className="mb-4">Okta CIC検証アプリ</h1>

    <p className="lead">
      <a href="https://reactjs.org">React.js</a>を使ったOkta CIC検証のためのサンプルSPA

    </p>

  </div>
);

export default Hero;
